import { render, staticRenderFns } from "./curSale-warehouse-discard-list.vue?vue&type=template&id=87761528&scoped=true"
import script from "./curSale-warehouse-discard-list.vue?vue&type=script&lang=js"
export * from "./curSale-warehouse-discard-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87761528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87761528')) {
      api.createRecord('87761528', component.options)
    } else {
      api.reload('87761528', component.options)
    }
    module.hot.accept("./curSale-warehouse-discard-list.vue?vue&type=template&id=87761528&scoped=true", function () {
      api.rerender('87761528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/warehouse-management/curSale-warehouse-store/curSale-warehouse-discard-list.vue"
export default component.exports